/* eslint-disable no-param-reassign */
const formatAMPM = (time = '', capitalise = false) => {
  time = time.toString().match(/^([01]\d|2[0-4])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];
  if (time.length > 1) {
    // If time format correct
    time.splice(-1, 1);
    time.splice(0, 1);
    time[3] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
    time[0] = +time[0] % 12 || 12;
  }
  return capitalise ? time.join('').toUpperCase() : time.join('');
};
export default formatAMPM;
